/*
 * @providesModule CircleProgressLevelStyle
 * 
 */

import SkillzStyle from 'SkillzStyle';
import {
  StyleSheet,
} from 'react-native';

const {
  fontBold,
  fontSecondary,
  fontExtraBold
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  mainContainer: {
    alignItems: 'center',
  },

  innerCircle: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  iconImg: {
    borderRadius: 4,
    paddingBottom: 2,
  },

  levelCircle: {
    alignItems: 'center',
    justifyContent: 'center',
  },

  currentLevelText: {
    ...fontBold,
    ...fontSecondary,
    margin: 8,
    textAlign: 'center',
    textAlignVertical: 'center',
    backgroundColor: 'transparent',
  },
    tierPercentageText: {
      ...fontExtraBold,
      ...fontSecondary,
      textAlign: 'center',
      color:'black',
    },
    tierPercentageTextContainer: {
      marginBottom:-6,
      paddingTop:2
    }
});
